import React from "react";
import RegisterForm from "../components/RegisterForm";
import logo from "../assets/logo.png";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import video from "../assets/video/demo-cargo-flow.mp4";
import { useLanguage, getMainTranslation } from "../hooks/useLanguage";
import { useTranslation } from "../hooks/useTranslation";
import english from "../assets/united-states.png";
import spanish from "../assets/spain.png";

function Register() {
  const navigate = useNavigate();
  const [isSpanish, setIsSpanish] = useLanguage();
  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-0">
      <div className="flex h-screen w-full">
        <div className="w-[50%] p-16 relative bg-[#EEF8F3]">
          <div className="w-full h-full flex items-center justify-center  rounded-2xl bg-[#EEF8F3]">
            <video src={video} autoPlay muted loop className="w-full h-full" />
          </div>
          <div className="size-16 bg-white absolute top-0 right-0">
            <div
              style={{
                borderTopRightRadius: "3rem",
              }}
              className="size-16 bg-[#EEF8F3]"
            ></div>
          </div>
          <div className="size-16 bg-[#EEF8F3] absolute bottom-0 right-[-4rem]">
            <div
              style={{
                borderBottomLeftRadius: "3rem",
              }}
                className="size-16 bg-white"
            ></div>
          </div>
        </div>
        <div className=" w-full p-8 flex flex-col justify-center">
          <div className="flex items-center gap-2 absolute top-4 left-0 px-4 w-full justify-between">
            <div
              className="cursor-pointer flex items-center gap-2"
              onClick={handleBack}
            >
              <ArrowLeft className="w-4 h-4" />
              <img src={logo} alt="Logo" className="logo-image !h-6" />
            </div>
            <button
              onClick={() => {
                setIsSpanish(!isSpanish);
              }}
              className={`cursor-pointer h-10 flex items-center gap-2 py-2 px-4 rounded-full transition-colors ${isSpanish ? "bg-yellow-100" : "bg-blue-100"}`}
            >
              <img
                src={isSpanish ? spanish : english}
                alt="Language"
                className="h-5"
              />
              <p className="text-sm">
                {isSpanish
                  ? getMainTranslation("esp", isSpanish)
                  : getMainTranslation("eng", isSpanish)}
              </p>
            </button>
          </div>
          <RegisterForm />
        </div>
      </div>
    </div>
  );
}

export default Register;
